import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Typography, Row, Col, Button, Space } from "antd";
import axiosInstance from "../../../configs";
import dayjs from "dayjs";
import "dayjs/locale/id";

dayjs.locale("id");

const { Title, Text } = Typography;

export default function PelekatanPrint() {
    const { id } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (id) {
            axiosInstance.get(`/pelekatan-pc/${id}/with-details`)
                .then(res => {
                    setData(res.data);
                })
                .catch(err => console.error(err))
                .finally(() => setLoading(false));
        }
    }, [id]);

    if (loading) return <div>Loading...</div>;
    if (!data) return <div>Data not found</div>;

    const { header, details } = data;

    const items = details || [];
    const formattedDate = header.tanggal_ba
        ? dayjs(header.tanggal_ba).format("D MMMM YYYY")
        : "-";

    return (
        <div style={{ padding: 40, fontFamily: 'Arial, sans-serif', maxWidth: 900, margin: '0 auto', background: "white" }}>
            {/* Header / Kop */}
            <div style={{ textAlign: "center", marginBottom: 20 }}>
                <img
                    src="/assets/media/logos/alb.png"
                    alt="ALB Logo"
                    style={{ width: 100, display: "block", margin: "0 auto 10px auto" }}
                />
            </div>

            <div style={{ textAlign: "center", marginBottom: 30 }}>
                <Title level={4} style={{ margin: 0, textTransform: "uppercase", textDecoration: "underline" }}>
                    BERITA ACARA PELEKATAN PITA CUKAI
                </Title>
                <Text>Nomor BA: {header.no_ba || "-"}</Text>
            </div>

            {/* Info Table */}
            <table style={{ width: "100%", marginBottom: 20, fontSize: 13, border: "none" }}>
                <tbody>
                    <tr>
                        <td style={{ width: 180, fontWeight: "bold" }}>Nomor CK-1A</td>
                        <td style={{ width: 10 }}>:</td>
                        <td>{header.no_ck1a || "-"}</td>
                    </tr>
                    <tr>
                        <td style={{ fontWeight: "bold" }}>Tanggal CK-1A</td>
                        <td>:</td>
                        <td>{header.tanggal_ck1a ? dayjs(header.tanggal_ck1a).format("DD-MM-YYYY") : "-"}</td>
                    </tr>
                    <tr>
                        <td style={{ fontWeight: "bold" }}>Tanggal Pelaksanaan</td>
                        <td>:</td>
                        <td>{formattedDate}</td>
                    </tr>
                </tbody>
            </table>

            <div style={{ marginBottom: 10, fontSize: 13 }}>
                <Text>Telah dilaksanakan pelekatan pita cukai dengan rincian sebagai berikut:</Text>
            </div>

            {/* Item Table */}
            <table style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #000", marginBottom: 20, fontSize: 12 }}>
                <thead>
                    <tr style={{ backgroundColor: "#f0f0f0" }}>
                        <th style={{ border: "1px solid #000", padding: "6px", textAlign: "center", width: 40 }}>No.</th>
                        <th style={{ border: "1px solid #000", padding: "6px", textAlign: "left" }}>Kode Barang</th>
                        <th style={{ border: "1px solid #000", padding: "6px", textAlign: "left", width: 200 }}>Nama Barang</th>
                        <th style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }}>Lot Asal</th>
                        <th style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }}>Jml Asal</th>
                        <th style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }}>Lot Tujuan</th>
                        <th style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }}>Jml Dilekatkan</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, index) => (
                        <tr key={index}>
                            <td style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }}>{index + 1}</td>
                            <td style={{ border: "1px solid #000", padding: "6px" }}>{item.item_code}</td>
                            <td style={{ border: "1px solid #000", padding: "6px" }}>{item.item_name || "-"}</td>
                            <td style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }}>{item.lot_asal}</td>
                            <td style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }}>{item.jumlah_kemasan}</td>
                            <td style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }}>{item.lot_tujuan}</td>
                            <td style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }}>{item.jumlah_kemasan_lekat}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Signatures */}
            <Row style={{ marginTop: 50, fontSize: 12 }}>
                <Col span={8} style={{ textAlign: "center" }}>
                    <div>Pelaksana,</div>
                    <div style={{ marginTop: 70, borderBottom: "1px solid #000", width: "80%", margin: "70px auto 0 auto" }}></div>
                    <div>(Staff Gudang)</div>
                </Col>
                <Col span={8} style={{ textAlign: "center" }}>
                    <div>Mengetahui,</div>
                    <div style={{ marginTop: 70, borderBottom: "1px solid #000", width: "80%", margin: "70px auto 0 auto" }}></div>
                    <div>(Manager Operasional)</div>
                </Col>
                <Col span={8} style={{ textAlign: "center" }}>
                    <div>Pengawas BC,</div>
                    <div style={{ marginTop: 70, borderBottom: "1px solid #000", width: "80%", margin: "70px auto 0 auto" }}></div>
                    <div>(Petugas Hanggar)</div>
                </Col>
            </Row>

            <style>{`
                @media print {
                    .print-controls { display: none !important; }
                    @page { margin: 2cm; }
                    body { -webkit-print-color-adjust: exact; background: white; }
                }
            `}</style>

            <div className="print-controls" style={{ marginTop: 40, textAlign: 'center' }}>
                <Button type="primary" onClick={() => window.print()}>Print / Cetak</Button>
            </div>
        </div>
    );
}
